import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=b23073f2&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=b23073f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23073f2",
  null
  
)

export default component.exports